
/**
 *
 * @status no delete
 * @class LocalStorageService
 */
class LocalStorageService {
  /**
   * @author Leonel Contreras
   * @description returns specific element from localstorage
   * @param {String} item
   * @returns {Object}
   * @memberof LocalStorageService
   */
  getLocalStorageItem = (item, isJSON = true) => {
    let itemJSON;

    try {
      itemJSON = localStorage.getItem(item)
      if (itemJSON && isJSON) itemJSON = JSON.parse(itemJSON)
    } catch (err) {
      itemJSON = null;
    }

    return itemJSON;
  };

  /**
   * @author Leonel Contreras
   * @description changes specific element from localstorage
   * @param {String} itemName
   * @param {Object} item
   * @returns {Boolean}
   * @memberof LocalStorageService
   */
  setLocalStorageItem = (itemName, item) => {
    localStorage.setItem(itemName, JSON.stringify(item));

    return true;
  };

  /**
   * @author Leonel Contreras
   * @description changes token and user in localStorage
   * @param {Object} token
   * @param {Object} user
   * @param {Array} modules
   * @returns {Boolean}
   * @memberof LocalStorageService
   */
  startLocalStorage = (token, user, modules) => {
    this.setLocalStorageItem("token", token);
    this.setLocalStorageItem("user", user);
    this.setLocalStorageItem("modules", modules);

    return true;
  };

  /**
   * @author Alan Aguilar
   * @description Set the start and finish time of user session with token in localStorage
   * @updatedDate 11-05-2021
   * @param {Object} token
   * @memberof LocalStorageService
   */
  timerSession = (token) => {
    let timeSessionStart = new Date();
    let msTokenExpiresIn = token.expiresIn * 1000; // Parse seconds to Miliseconds
    let msTimeSessionStart = timeSessionStart.getTime();
    let msTimeSessionEnd = msTimeSessionStart + msTokenExpiresIn;
    let timeSessionEnd = new Date(msTimeSessionEnd);
    let timeSession = { timeSessionStart, timeSessionEnd };
    this.setLocalStorageItem("timeSession", timeSession);
  };

  /**
   * @author Leonel Contreras
   * @description clear localStorage
   * @returns {Boolean}
   * @memberof LocalStorageService
   */
  clearLocalStorage = () => {
    localStorage.clear();

    return true;
  };

  deleteElementLocalStorage = (name) => {
    localStorage.removeItem(name);

    return true;
  };
}

export { LocalStorageService as default };
